import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'

import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default{
    name: 'buissnesssubvertical',
    components: {
        Paginate,
        VueElementLoading
    },
    data: function() {
        return {
            modalShow: false,
            addverticalmodal: false,
            verticalaction: '',
            listverticalData: [],
            listverticalData1: [],
            props: [],
            pageno: 0,
            pagecount: 0,
            sub_vertical:'',
            buiness_vertical:'',
            buiness_vertical_id:0,
            searchid: '',
            id:0,
            isLoading: false,
            resultCount: '',
            isactive: '',
            changestatus: '',
            count: 0
        }
    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        this.localuserid = userdetail.userid;
        this.localusername = userdetail.username;
        this.getverticalData();
    },
    methods: {
        addnewvertical() {
            this.isactive = 'true',
            this.sub_vertical = '',
            this.buiness_vertical = '',
            this.verticalaction = 'add',
            this.addverticalmodal = true,
            this.getBverticalData();
            this.$validator.reset();
            this.errors.clear();
        },
        closeAddverticalModal() {
            $("#verticalform").trigger("reset");
            this.addverticalmodal = false;
            this.$validator.reset();
            this.errors.clear();
        },
        closeStatusverticalModal() {
            this.modalShow = false
        },
        searchData(){
            this.pageno = 0;
            this.$refs.paginate.selected = 0;
            this.getverticalData();
          },
        getverticalData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                offset: this.pageno,
                limit: 10,
                sub_vertical: this.searchid
            })
            this.isLoading = true;

            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'GetBSVerticalsList ',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.listverticalData = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count
                    this.resultCount = result.data.count
                    if (totalRows < 10) {
                        this.pagecount = 1
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10)
                    }
                }, error => {
                    console.error(error)
                })
        },
        getBverticalData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
              
            })
            this.isLoading = true;

            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'GetBverticalslist ',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.listverticalData1 = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count
                    this.resultCount = result.data.count
                    if (totalRows < 10) {
                        this.pagecount = 1
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10)
                    }
                }, error => {
                    console.error(error)
                })
        },
        savevertical(event) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
  
            this.input = ({
                sub_vertical: this.sub_vertical,
                buiness_vertical_id: this.buiness_vertical,

            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'Createbuinesssubverticals',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then((response) => {
                if (response.data.errorCode == 0) {
                    this.$alertify.success(response.data.msg);
                    this.addverticalmodal = false;
                    event.target.reset();
                    this.resetForm();
                } else if (response.data.errorCode == -1) {
                    this.$alertify.error(response.data.msg)
                }
  
              iptrackerdetails.checkUserIP(this.iptrackData,'Save sub vertical',this.$route.path,this.input,response.data);
  
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            });
          },
  
        getverticalRowData(data) {
            this.$validator.reset();
            this.errors.clear();
            this.verticalaction = 'edit';
            this.addverticalmodal = true;
            this.buiness_vertical_id = data.buiness_vertical_id;
            this.sub_vertical = data.sub_vertical;
            this.isactive = data.isactive;
        },
        editvertical(event) {

        },

        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getverticalData()
        },



        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result){
              //console.log('form is valid', this.model);
              if(this.id!=undefined && this.id!=""){
                this.editvertical(event);
              }else{
                this.savevertical(event);
                this.getverticalData();                
              }
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        },
        resetSearch(){
          this.searchid = '';
          this.pageno = 0;
          this.$refs.paginate.selected = 0;
          this.getverticalData();
        },
        resetForm() {
            this.sub_vertical = '';
            this.buiness_vertical_id = '';
            this.verticalaction = 'add';
            this.isactive = '';
            this.$validator.reset();
            this.errors.clear();
            this.getverticalData();
        }

    }
};


// WEBPACK FOOTER //
// ./src/views/components/buissnesssubvertical/buissnesssubvertical.js